import axios from 'axios';

const normalizeSecureUrl = url => {
  if (!url) return url;

  try {
    const parsedUrl = new URL(url, window.location.origin);

    if (
      typeof window !== 'undefined' &&
      window.location.protocol === 'https:' &&
      parsedUrl.protocol === 'http:' &&
      parsedUrl.host === window.location.host
    ) {
      parsedUrl.protocol = 'https:';
    }

    return parsedUrl.toString().replace(/\/$/, '');
  } catch {
    return String(url).replace(/^http:\/\//i, 'https://').replace(/\/$/, '');
  }
};

// Development: http://localhost:5000/api
// Production: https://api.yourdomain.com/api (update with your actual domain)
export const API_BASE_URL = normalizeSecureUrl(process.env.REACT_APP_API_URL || 'http://localhost:5000/api');
export const uploadsBaseUrl =
  normalizeSecureUrl(process.env.REACT_APP_UPLOADS_URL) ||
  normalizeSecureUrl(`${API_BASE_URL.replace(/\/api\/?$/, '')}/uploads`);
export const storageBaseUrl =
  normalizeSecureUrl(process.env.REACT_APP_STORAGE_URL) ||
  normalizeSecureUrl(`${API_BASE_URL.replace(/\/api\/?$/, '')}/storage`);

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Attach auth token to every request when available
api.interceptors.request.use(config => {
  const token = localStorage.getItem('fe_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors consistently
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('fe_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
